import React from 'react'
import { DocumentModal } from 'components'
import { LuBuilding, LuBuilding2, LuCalendarDays, LuFileText, LuMapPin, LuUser } from 'react-icons/lu';
import './gstDetail.css'
// import { utils } from 'helper';

const GstDetailModal = (props) => {
    let {
        onRefresh,
        onUpdate = () => { },
        onContinue = () => { },
        isOpen,
        onClose = () => { },
        modalZIndex,
    } = props;

    const footer = (
        <>
            <button
                className="_gst_insertBtn"
                onClick={onUpdate}
            >
                Insert
            </button>
            <button
                className="_gst_continueBtn"
                onClick={onContinue}
            >
                Continue
            </button>
        </>
    );

    console.log('isOpen', isOpen)

    return (
        <>
            <div className="__gstDetail_main_container">
                <DocumentModal
                    isOpen={isOpen}
                    onClose={(e) => onClose(e)}
                    modalZIndex={modalZIndex}
                    footer={footer}
                    {...props}
                >
                    <div className="__gstDetail_main">
                        {/* Header */}
                        <div className="__gstDetail_header">
                            <LuBuilding2 />
                            <h2>GST Details</h2>
                        </div>

                        {/* Status Card */}
                        <div className={isOpen?.gstnStatus === 'Cancelled' ? "__gst_statusBox_cancelled" : "__gst_statusBox"}>
                            <div>
                                <p>Status</p>
                                <h4> {isOpen?.gstnStatus} </h4>
                            </div>

                            <span className={isOpen?.gstnStatus === 'Cancelled' ? "__status_dot_cancelled" : "__status_dot"}></span>
                        </div>

                        {/* Details Grid */}
                        <div className="__gst_grid">

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuFileText />
                                </div>

                                <div>
                                    <p>GSTIN</p>
                                    <h5>{isOpen?.gstIdentificationNumber || ''}</h5>
                                </div>
                            </div>

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuCalendarDays />
                                </div>

                                <div>
                                    <p>Registration Date</p>
                                    <h5>{isOpen?.dateOfRegistration || ''}</h5>
                                </div>
                            </div>

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuBuilding />
                                </div>

                                <div>
                                    <p>Legal Name</p>
                                    <h5>{isOpen?.legalNameOfBusiness || ''}</h5>
                                </div>
                            </div>

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuBuilding />
                                </div>

                                <div>
                                    <p>Trade Name</p>
                                    <h5>{isOpen?.tradeName || ''}</h5>
                                </div>
                            </div>

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuUser />
                                </div>

                                <div>
                                    <p>Business Type</p>
                                    <h5>{isOpen?.principalPlaceOfBusinessFields?.natureOfPrincipalPlaceOfBusiness || ''}</h5>
                                </div>
                            </div>

                            <div className="__gst_card">
                                <div className="__gst_icon">
                                    <LuUser />
                                </div>

                                <div>
                                    <p>Taxpayer Type</p>
                                    <h5>{isOpen?.taxpayerType || ''}</h5>
                                </div>
                            </div>

                        </div>

                        {/* Address */}
                        <div className="__gst_addressBox">
                            <div className="__gst_icon">
                                <LuMapPin />
                            </div>

                            <div>
                                <p>Address</p>

                                <h5>
                                    {`${isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.location} ${isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.streetName || ''}, ${isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.buildingName}, ${isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName}, ${isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.pincode}`}
                                </h5>

                                <span>State: {isOpen?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName || ""}</span>
                            </div>
                        </div>

                    </div>
                </DocumentModal>
                <div className="offBack_drop"></div>
            </div>
        </>
    )
}

export default GstDetailModal